import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'
import { zervantSettingsQueryKey } from '@features/invoicingSettings/constants/zervantSettingsQueryKey'
import { useUpdateZervantSettings } from '@features/invoicingSettings/hooks/useUpdateZervantSettings'
import { useZervantSettings } from '@features/invoicingSettings/hooks/useZervantSettings'

import { queryClient } from '../../../../../config/queryClient'

export const useUpdateInvoiceColumnsVisibilitySettings = () => {
  const { data: zervantSettings } = useZervantSettings()
  const { update, isProcessing } = useUpdateZervantSettings()

  const updateInvoiceColumnsVisibilitySettings = (columns: InvoiceLineColumn[]) => {
    if (!zervantSettings || isProcessing) {
      return
    }

    update(
      {
        ...zervantSettings,
        models: zervantSettings.models.map((model) => {
          if (model.type !== InvoiceDocumentType.Invoice) {
            return model
          }

          return {
            ...model,
            fields: model.fields.map((field) =>
              field.name === 'columns' ? { ...field, default: columns.join(',') } : field,
            ),
          }
        }),
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(zervantSettingsQueryKey)
        },
      },
    )
  }

  return { isProcessing, updateInvoiceColumnsVisibilitySettings }
}
